import { Field, InfoLabel, Input, makeStyles } from "@fluentui/react-components";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IMinMaxInputProps } from "./min-max-input.props";

const layoutStyles = makeStyles({
    inputWrapper: {
        marginBottom: '1em',
        maxWidth: '300px'
    }
});

/**
 * Generic input component for numeric values with min/max validation
 * Displays success/error state based on whether value is within range
 */
export default function MinMaxInput(props: IMinMaxInputProps) {
    const { t } = useL10n<ILocaleStrings>();
    const styles = layoutStyles();

    const isValid = props.value >= props.min && props.value <= props.max;

    const handleChange = (value: string) => {
        const numValue = parseInt(value, 10);
        props.onChange(isNaN(numValue) ? 0 : numValue);
    };

    // Use generic validation message with field name, min, and max values
    const validationMessage = !isValid
        ? t("ppaValidationMinMaxValueMessage", {
            field: props.label,
            min: props.min,
            max: props.max
        })
        : undefined;

    return (
        <div className={styles.inputWrapper}>
            <Field
                label={
                    props.tooltip ? (
                        <InfoLabel info={props.tooltip}>
                            {props.label}
                        </InfoLabel>
                    ) : (
                        props.label
                    )
                }
                required={props.required}
                validationMessage={validationMessage}
                validationState={isValid ? "success" : "error"}
            >
                <Input
                    type="number"
                    value={props.value?.toString() ?? ""}
                    onChange={(e, data) => handleChange(data.value)}
                    min={props.min}
                    max={props.max}
                />
            </Field>
        </div>
    );
}
